import { render, staticRenderFns } from "./GridFooter.vue?vue&type=template&id=b0ad24a0&scoped=true&"
import script from "./GridFooter.vue?vue&type=script&lang=ts&"
export * from "./GridFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GridFooter.vue?vue&type=style&index=0&id=b0ad24a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ad24a0",
  null
  
)

export default component.exports